<c11n-chip
    [labelText]="factorStatusName"
    [color]="factorStatusColor"
></c11n-chip>